import './add.less';
import PropTypes from 'prop-types';
import React from 'react';

const Add = ({
	intl,
	showFiltersList
}) => (
	<div className="filters-add" onClick={showFiltersList}>
		<span className="filters-add__title">{intl('Add filters')}</span>
	</div>
);

Add.propTypes = {
	showFiltersList: PropTypes.func,
	intl: PropTypes.func
};

export default Add;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/filters/components/add.js